import { ElLoading } from 'element-plus'

export const useDirective = app => {
  app.directive('loading', ElLoading.directive)
}